import React from "react";

const ServicesContext = React.createContext({});

export default ServicesContext;